import { STATISTICS_PERIOD_DEFAULT, isStatisticsPeriod, type StatisticsPeriod } from '@easyhelp/shared';

/** Testo di un dato assente: la vista lo dichiara, mai uno zero o un trattino al suo posto. */
export const NO_DATA = 'Nessun dato nel periodo';

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * Durata compatta in italiano, al minuto: «meno di 1 min», «45 min», «3 h 10 min», «1 g 4 h».
 * Sopra il giorno i minuti non si mostrano: per una mediana di giorni sarebbero rumore.
 */
export function formatDuration(seconds: number): string {
  if (seconds < MINUTE) return 'meno di 1 min';
  const total = Math.round(seconds / MINUTE) * MINUTE;
  const days = Math.floor(total / DAY);
  const hours = Math.floor((total % DAY) / HOUR);
  const minutes = Math.floor((total % HOUR) / MINUTE);
  if (days > 0) return hours > 0 ? `${days} g ${hours} h` : `${days} g`;
  if (hours > 0) return minutes > 0 ? `${hours} h ${minutes} min` : `${hours} h`;
  return `${minutes} min`;
}

/** Quota percentuale arrotondata; `null` se la base è vuota (non «0%»: non c'è un dato). */
export function formatShare(count: number, total: number): string | null {
  if (total === 0) return null;
  return `${Math.round((count / total) * 100)}%`;
}

const day = new Intl.DateTimeFormat('it-IT', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'Europe/Rome',
});

/** Primo giorno del periodo, nel fuso di Roma: «26 settembre 2026». */
export function formatDay(iso: string): string {
  return day.format(new Date(iso));
}

/** Periodo dall'URL (`?periodo=7`): un valore assente o non ammesso vale il default (30 giorni). */
export function readPeriod(search: URLSearchParams): StatisticsPeriod {
  const value = Number(search.get('periodo'));
  return isStatisticsPeriod(value) ? value : STATISTICS_PERIOD_DEFAULT;
}

/** Scrive il periodo nell'URL, omettendo il default. */
export function writePeriod(period: StatisticsPeriod): URLSearchParams {
  return new URLSearchParams(period === STATISTICS_PERIOD_DEFAULT ? {} : { periodo: String(period) });
}
